module.exports = __webpack_public_path__ + "img/ico-in-call.1e48ce3e.svg";